import axios from "./api";

export const generateDeviceId = () => {
    let result = "";
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for (let i = 0; i < 16; i++) {
        result += characters.charAt(
            Math.floor(Math.random() * characters.length)
        );
    }
    return result;
}

export const getOTP = (data) => {
    return axios.post('/GetOTP', data)
}

export const sendOTP = (data) => {
    return axios.post('/SendOTP', data)
}

export const forgotPassword = (data) => {
    return axios.post('/ResetPassword', data)
}

export const linkedInAuth = (data) => {
    return axios.post('/LinkedInLogin', data)
}